<template>
  <header class="app-page-not-found-header">
    <h1 class="title">Not found</h1>
    <div class="content-wrapper">
      <div v-if="$slots.content" class="content">
        <slot name="content" />
      </div>
      <slot name="action">
        <AppButton centered max-width="250px" replace :to="actionTo">{{ actionName }}</AppButton>
      </slot>
    </div>
  </header>
</template>

<script>
import AppButton from '@/components/AppButton.vue';

export default {
  name: 'AppPageNotFoundHeader',
  components: { AppButton },
  props: {
    actionName: {
      type: String,
      default: 'Go to Home',
    },
    actionTo: {
      type: [String, Object],
      default: '/',
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-page-not-found-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 60px;
  width: 100%;
  height: 66vh;
  max-height: 400px;
  padding: 0 16px;
  background-image: url(~@/assets/images/bg-page-not-found.webp);
  background-repeat: no-repeat;
  background-position: left bottom;
  background-size: cover;

  .title {
    font-size: 22px;
    font-weight: 700;
    letter-spacing: 0.4em;
    text-transform: uppercase;
    color: vars.$c-dark-gray;

    @media (min-width: vars.$tablet-break-point + 1) {
      font-size: 32px;
    }
  }

  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 36px;
    width: 100%;
  }

  .content {
    display: flex;
    flex-direction: column;
    gap: 12px;
    text-align: center;
    font-size: 18px;
  }
}
</style>
